export const getDeveloperLink = (id?: number | null): string | undefined =>
  id ? `/zastroishchik-kompaniia-i-${id}/` : undefined;
